import { createIcon, defaultProps } from "@chakra-ui/react";
import React from "react";
import { motion } from "framer-motion";

const svgVariants = {
  hidden: {
    rotate: 0,
  },
  visible: {
    rotate: 90,
    transition: {
      delay: 1,
      duration: 1.5,
    },
  },
};

const pathVariants = {
  hidden: {
    pathLength: 0,
    pathOffset: 1,
    opacity: 0,
    fillOpacity: -15,
    //strokeOpacity: 15,
  },
  visible: {
    pathLength: 1,
    pathOffset: 0,
    opacity: 1,
    fillOpacity: 1,
    //strokeOpacity: 0,
    transition: {
      duration: 3,
      ease: "easeInOut",
      //type: "spring",
      //stiffness: 20,
    },
  },
};

const IconPattern = createIcon({
  defaultProps,
  displayName: "IconPattern",
  viewBox: "0 0 252.4 252.4",
  path: (
    <motion.svg variants={svgVariants} initial="hidden" animate="visible">
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M231.72 20.68c13.79,13.78 20.68,31.86 20.68,49.93 0,18.07 -6.9,36.14 -20.68,49.93 -13.78,13.78 -31.86,20.68 -49.93,20.68 -18.07,0 -36.14,-6.9 -49.93,-20.68l4.56 -4.56c12.53,12.53 28.95,18.79 45.37,18.79 16.42,0 32.84,-6.26 45.37,-18.79 12.53,-12.53 18.79,-28.95 18.79,-45.37 0,-16.42 -6.27,-32.84 -18.79,-45.37l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M223.78 28.62c11.59,11.59 17.39,26.79 17.39,41.99 0,15.19 -5.8,30.4 -17.39,41.99 -11.59,11.59 -26.79,17.39 -41.99,17.39 -15.19,0 -30.39,-5.8 -41.99,-17.39l4.56 -4.56c10.34,10.34 23.88,15.5 37.43,15.5 13.54,0 27.09,-5.17 37.42,-15.5 10.34,-10.34 15.51,-23.88 15.51,-37.43 0,-13.55 -5.17,-27.09 -15.5,-37.43l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M215.84 36.56c9.4,9.4 14.1,21.72 14.1,34.05 0,12.32 -4.7,24.64 -14.1,34.05 -9.4,9.4 -21.72,14.1 -34.05,14.1 -12.32,0 -24.64,-4.7 -34.05,-14.1l4.56 -4.56c8.14,8.14 18.82,12.22 29.49,12.22 10.67,0 21.34,-4.08 29.49,-12.22 8.14,-8.14 12.21,-18.82 12.21,-29.49 0,-10.67 -4.07,-21.34 -12.21,-29.49l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M207.89 44.51c7.21,7.21 10.81,16.66 10.81,26.1 0,9.45 -3.6,18.9 -10.81,26.11 -7.21,7.21 -16.66,10.81 -26.1,10.81 -9.45,0 -18.9,-3.61 -26.11,-10.81l4.56 -4.56c5.95,5.95 13.75,8.92 21.55,8.92 7.8,0 15.6,-2.98 21.54,-8.92 5.95,-5.95 8.93,-13.75 8.93,-21.55 0,-7.8 -2.98,-15.6 -8.93,-21.54l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M199.94 52.45c5.02,5.02 7.54,11.6 7.54,18.16 0,6.57 -2.51,13.15 -7.52,18.16 -5.01,5.01 -11.59,7.52 -18.16,7.52 -6.57,0 -13.15,-2.51 -18.16,-7.52l4.56 -4.56c3.76,3.76 8.68,5.64 13.6,5.64 4.92,0 9.85,-1.88 13.6,-5.63 3.76,-3.76 5.64,-8.68 5.64,-13.61 0,-4.93 -1.88,-9.86 -5.62,-13.6l4.53 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M192.01 60.39c2.82,2.82 4.23,6.52 4.23,10.22 0,3.7 -1.41,7.4 -4.23,10.22 -2.82,2.82 -6.52,4.23 -10.22,4.23 -3.7,0 -7.4,-1.41 -10.22,-4.23l4.56 -4.56c1.56,1.57 3.61,2.35 5.66,2.35 2.05,0 4.1,-0.78 5.66,-2.35 1.56,-1.56 2.35,-3.61 2.35,-5.66 0,-2.05 -0.78,-4.1 -2.35,-5.66l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M76.27 176.13c-13.78,-13.79 -20.68,-31.86 -20.68,-49.93 0,-18.07 6.9,-36.14 20.68,-49.93 13.79,-13.78 31.86,-20.68 49.93,-20.68 18.07,0 36.14,6.9 49.93,20.68l-4.56 4.56c-12.53,-12.53 -28.95,-18.79 -45.37,-18.79 -16.42,0 -32.84,6.27 -45.37,18.79 -12.53,12.53 -18.79,28.95 -18.79,45.37 0,16.42 6.27,32.84 18.79,45.37l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M84.21 168.19c-11.59,-11.59 -17.39,-26.79 -17.39,-41.99 0,-15.2 5.8,-30.4 17.39,-41.99 11.59,-11.59 26.79,-17.39 41.99,-17.39 15.2,0 30.4,5.8 41.99,17.39l-4.56 4.56c-10.33,-10.34 -23.88,-15.5 -37.43,-15.5 -13.55,0 -27.09,5.17 -37.43,15.5 -10.34,10.33 -15.5,23.88 -15.5,37.43 0,13.55 5.17,27.09 15.5,37.43l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M92.15 160.25c-9.4,-9.4 -14.1,-21.72 -14.1,-34.04 0,-12.32 4.7,-24.64 14.1,-34.04 9.4,-9.4 21.73,-14.1 34.05,-14.1 12.32,0 24.64,4.7 34.04,14.1l-4.56 4.56c-8.14,-8.14 -18.82,-12.21 -29.49,-12.21 -10.67,0 -21.34,4.07 -29.48,12.21 -8.14,8.15 -12.22,18.82 -12.22,29.49 0,10.67 4.07,21.34 12.21,29.48l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M100.09 152.31c-7.21,-7.21 -10.81,-16.66 -10.81,-26.11 0,-9.45 3.61,-18.9 10.81,-26.11 7.21,-7.21 16.66,-10.81 26.11,-10.81 9.45,0 18.9,3.61 26.11,10.81l-4.56 4.56c-5.95,-5.95 -13.75,-8.93 -21.54,-8.93 -7.8,0 -15.6,2.98 -21.54,8.93 -5.95,5.95 -8.93,13.75 -8.93,21.54 0,7.8 2.98,15.6 8.93,21.54l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M108.04 144.35c-5.01,-5.01 -7.52,-11.58 -7.52,-18.15 0,-6.57 2.51,-13.13 7.52,-18.15 5.01,-5.03 11.59,-7.54 18.16,-7.54 6.57,0 13.15,2.51 18.16,7.52l-4.56 4.56c-3.75,-3.76 -8.68,-5.63 -13.6,-5.63 -4.92,0 -9.85,1.88 -13.6,5.63 -3.76,3.75 -5.63,8.68 -5.63,13.6 0,4.93 1.88,9.86 5.63,13.62l-4.56 4.53z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M115.98 136.42c-2.82,-2.82 -4.23,-6.53 -4.23,-10.22 0,-3.7 1.41,-7.4 4.23,-10.22 2.82,-2.82 6.53,-4.23 10.22,-4.23 3.7,0 7.4,1.41 10.22,4.23l-4.56 4.56c-1.56,-1.57 -3.61,-2.35 -5.66,-2.35 -2.05,0 -4.1,0.78 -5.66,2.34 -1.57,1.57 -2.35,3.62 -2.35,5.66 0,2.05 0.78,4.1 2.34,5.66l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M112.12 59.19c1.17,-7.16 3.45,-14.19 6.84,-20.8 3.28,-6.4 7.59,-12.39 12.9,-17.7 13.79,-13.79 31.86,-20.68 49.93,-20.68 18.07,0 36.14,6.9 49.93,20.68l-4.56 4.56c-12.53,-12.53 -28.95,-18.79 -45.37,-18.79 -16.42,0 -32.84,6.27 -45.37,18.79 -4.87,4.87 -8.79,10.31 -11.75,16.07 -3.07,6 -5.15,12.38 -6.21,18.91l-6.34 -1.03z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M123.73 58.16c1.17,-5.49 3.14,-10.86 5.89,-15.92 2.66,-4.89 6.05,-9.48 10.18,-13.6 11.58,-11.6 26.79,-17.4 41.98,-17.4 15.2,0 30.4,5.8 41.99,17.39l-4.56 4.56c-10.34,-10.34 -23.88,-15.5 -37.43,-15.5 -13.55,0 -27.1,5.17 -37.43,15.5 -3.7,3.68 -6.73,7.77 -9.09,12.12 -2.44,4.49 -4.19,9.27 -5.24,14.19l-6.3 -1.34z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M135.04 59.13c1.03,-4.19 2.63,-8.28 4.81,-12.14 2.1,-3.75 4.74,-7.26 7.9,-10.42 9.4,-9.4 21.73,-14.1 34.05,-14.1 12.32,0 24.65,4.7 34.05,14.1l-4.56 4.56c-8.14,-8.14 -18.81,-12.21 -29.49,-12.21 -10.67,0 -21.34,4.07 -29.49,12.21 -2.76,2.75 -5.05,5.79 -6.86,9.01 -1.89,3.32 -3.28,6.87 -4.16,10.51l-6.25 -1.51z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M145.88 62.04c0.77,-3.24 2,-6.42 3.68,-9.43 1.62,-2.92 3.67,-5.65 6.12,-8.1 7.21,-7.21 16.66,-10.81 26.11,-10.81 9.45,0 18.9,3.6 26.1,10.81l-4.56 4.56c-5.95,-5.95 -13.75,-8.93 -21.54,-8.93 -7.8,0 -15.6,2.98 -21.55,8.93 -2.04,2.04 -3.73,4.29 -5.06,6.68 -1.38,2.44 -2.39,5.07 -3.03,7.78l-6.27 -1.49z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M156.34 67.21c0.37,-2.75 1.18,-5.46 2.43,-7.98 1.21,-2.44 2.83,-4.73 4.87,-6.77 5.01,-5.02 11.58,-7.53 18.15,-7.53 6.56,0 13.14,2.51 18.16,7.54l-4.56 4.53c-3.74,-3.75 -8.67,-5.62 -13.6,-5.62 -4.92,0 -9.85,1.88 -13.6,5.63 -1.54,1.52 -2.75,3.23 -3.65,5.06 -0.94,1.9 -1.55,3.92 -1.82,5.97l-6.37 -0.83z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M171.57 80.83c-2.82,-2.82 -4.23,-6.52 -4.23,-10.22 0,-3.7 1.41,-7.4 4.23,-10.22 2.82,-2.82 6.52,-4.23 10.22,-4.23 3.7,0 7.4,1.41 10.22,4.23l-4.56 4.56c-1.56,-1.56 -3.61,-2.35 -5.66,-2.35 -2.05,0 -4.1,0.78 -5.66,2.35 -1.57,1.56 -2.35,3.61 -2.35,5.66 0,2.05 0.78,4.1 2.35,5.66l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M120.54 131.86c13.78,13.79 20.68,31.86 20.68,49.93 0,18.07 -6.9,36.14 -20.68,49.93 -13.79,13.79 -31.86,20.68 -49.93,20.68 -18.07,0 -36.14,-6.89 -49.93,-20.68l4.56 -4.56c12.53,12.53 28.95,18.79 45.37,18.79 16.42,0 32.84,-6.27 45.37,-18.79 12.53,-12.53 18.8,-28.95 18.8,-45.37 0,-16.42 -6.27,-32.84 -18.8,-45.37l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M112.6 139.8c11.59,11.6 17.39,26.79 17.39,41.99 0,15.19 -5.8,30.39 -17.39,41.99 -11.59,11.59 -26.79,17.39 -41.99,17.39 -15.19,0 -30.4,-5.8 -41.99,-17.39l4.56 -4.56c10.34,10.34 23.88,15.5 37.43,15.5 13.55,0 27.1,-5.17 37.43,-15.5 10.34,-10.34 15.5,-23.88 15.5,-37.43 0,-13.54 -5.17,-27.09 -15.5,-37.42l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M104.65 147.75c9.4,9.4 14.1,21.72 14.1,34.05 0,12.32 -4.7,24.64 -14.1,34.05 -9.4,9.4 -21.72,14.1 -34.05,14.1 -12.32,0 -24.64,-4.7 -34.05,-14.1l4.56 -4.56c8.14,8.14 18.82,12.21 29.49,12.21 10.67,0 21.35,-4.07 29.49,-12.21 8.14,-8.14 12.22,-18.82 12.22,-29.49 0,-10.67 -4.07,-21.35 -12.22,-29.49l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M96.71 155.69c7.21,7.21 10.81,16.66 10.81,26.11 0,9.45 -3.6,18.9 -10.81,26.1 -7.21,7.21 -16.66,10.81 -26.11,10.81 -9.45,0 -18.9,-3.6 -26.1,-10.81l4.56 -4.56c5.95,5.95 13.75,8.93 21.54,8.93 7.8,0 15.6,-2.98 21.55,-8.93 5.95,-5.95 8.92,-13.75 8.92,-21.54 0,-7.8 -2.98,-15.6 -8.92,-21.55l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M88.77 163.63c5.01,5.02 7.52,11.59 7.52,18.16 0,6.57 -2.51,13.15 -7.52,18.16 -5.02,5.01 -11.59,7.52 -18.17,7.52 -6.56,0 -13.13,-2.51 -18.15,-7.52l4.53 -4.56c3.75,3.76 8.68,5.63 13.61,5.63 4.92,0 9.85,-1.88 13.6,-5.63 3.76,-3.76 5.64,-8.68 5.64,-13.6 0,-4.92 -1.88,-9.85 -5.63,-13.6l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M80.83 171.57c2.82,2.82 4.23,6.52 4.23,10.22 0,3.7 -1.41,7.4 -4.23,10.22 -2.84,2.82 -6.53,4.23 -10.22,4.23 -3.69,0 -7.39,-1.41 -10.21,-4.23l4.53 -4.56c1.57,1.56 3.62,2.35 5.68,2.35 2.05,0 4.1,-0.78 5.67,-2.34 1.56,-1.57 2.34,-3.62 2.34,-5.67 0,-2.05 -0.78,-4.1 -2.35,-5.66l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M60.22 118.47c-6.53,1.06 -12.91,3.14 -18.91,6.21 -5.76,2.96 -11.19,6.87 -16.07,11.75 -12.53,12.53 -18.79,28.95 -18.79,45.37 0,16.42 6.27,32.84 18.79,45.37l-4.56 4.56c-13.79,-13.78 -20.68,-31.86 -20.68,-49.93 0,-18.07 6.89,-36.14 20.68,-49.93 5.32,-5.32 11.3,-9.62 17.7,-12.9 6.61,-3.39 13.64,-5.67 20.8,-6.84l1.03 6.34z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M59.49 130.03c-4.91,1.05 -9.7,2.8 -14.19,5.24 -4.35,2.37 -8.44,5.39 -12.12,9.08 -10.34,10.35 -15.5,23.9 -15.5,37.44 0,13.55 5.17,27.09 15.5,37.43l-4.56 4.56c-11.59,-11.59 -17.39,-26.79 -17.39,-41.99 0,-15.2 5.8,-30.4 17.39,-41.99 4.13,-4.12 8.72,-7.51 13.61,-10.17 5.06,-2.75 10.43,-4.72 15.92,-5.89l1.34 6.3z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M60.64 141.29c-3.64,0.89 -7.18,2.27 -10.51,4.15 -3.22,1.82 -6.25,4.11 -9.01,6.87 -8.14,8.14 -12.21,18.81 -12.21,29.49 0,10.67 4.07,21.34 12.21,29.49l-4.56 4.56c-9.4,-9.4 -14.1,-21.73 -14.1,-34.05 0,-12.32 4.7,-24.65 14.1,-34.05 3.17,-3.16 6.68,-5.8 10.42,-7.91 3.86,-2.17 7.95,-3.77 12.14,-4.8l1.51 6.25z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M63.52 152.16c-2.71,0.64 -5.34,1.65 -7.79,3.02 -2.38,1.34 -4.63,3.03 -6.67,5.07 -5.95,5.95 -8.93,13.75 -8.93,21.55 0,7.8 2.98,15.59 8.93,21.54l-4.56 4.56c-7.21,-7.21 -10.81,-16.66 -10.81,-26.1 0,-9.45 3.6,-18.9 10.81,-26.11 2.45,-2.45 5.18,-4.5 8.08,-6.12 3.02,-1.68 6.2,-2.92 9.45,-3.68l1.49 6.27z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M68.03 162.72c-2.05,0.27 -4.07,0.88 -5.97,1.82 -1.83,0.9 -3.54,2.12 -5.06,3.64 -3.76,3.77 -5.63,8.7 -5.63,13.62 0,4.93 1.88,9.86 5.63,13.61l-4.56 4.53c-5.01,-5.01 -7.52,-11.58 -7.52,-18.15 0,-6.57 2.51,-13.15 7.52,-18.16 2.04,-2.03 4.33,-3.65 6.77,-4.86 2.53,-1.25 5.23,-2.06 7.98,-2.43l0.83 6.37z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M76.27 176.13c-1.56,-1.57 -3.61,-2.35 -5.66,-2.35 -2.05,0 -4.1,0.78 -5.66,2.35 -1.57,1.56 -2.35,3.61 -2.35,5.66 0,2.06 0.78,4.11 2.35,5.68l-4.56 4.53c-2.82,-2.82 -4.23,-6.52 -4.23,-10.21 0,-3.69 1.41,-7.39 4.23,-10.21 2.82,-2.84 6.52,-4.25 10.22,-4.25 3.7,0 7.4,1.41 10.22,4.23l-4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M195.87 137.63c-1.17,7.16 -3.45,14.19 -6.84,20.8 -3.29,6.4 -7.59,12.39 -12.9,17.71 -5.32,5.32 -11.3,9.62 -17.71,12.9 -6.61,3.39 -13.64,5.67 -20.8,6.84l-1.03 -6.35c6.53,-1.06 12.91,-3.14 18.91,-6.21 5.77,-2.95 11.2,-6.87 16.07,-11.75 4.87,-4.87 8.79,-10.3 11.75,-16.07 3.08,-6 5.15,-12.38 6.21,-18.91l6.35 1.03z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M184.26 138.66c-1.17,5.49 -3.14,10.86 -5.9,15.92 -2.66,4.89 -6.05,9.48 -10.17,13.6l-0.01 0.01c-4.12,4.12 -8.71,7.51 -13.6,10.17 -5.06,2.75 -10.43,4.73 -15.92,5.9l-1.34 -6.3c4.91,-1.05 9.69,-2.8 14.19,-5.24 4.34,-2.37 8.44,-5.4 12.13,-9.08 3.69,-3.69 6.72,-7.79 9.08,-12.13 2.44,-4.49 4.19,-9.27 5.24,-14.19l6.3 1.34z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M172.95 137.69c-1.03,4.19 -2.63,8.28 -4.81,12.14 -2.12,3.76 -4.75,7.27 -7.9,10.42 -3.15,3.15 -6.66,5.78 -10.42,7.9 -3.86,2.18 -7.95,3.78 -12.14,4.81l-1.51 -6.25c3.64,-0.89 7.18,-2.28 10.51,-4.15 3.19,-1.8 6.23,-4.09 9.01,-6.87 2.78,-2.78 5.07,-5.82 6.87,-9.01 1.88,-3.32 3.26,-6.87 4.15,-10.51l6.25 1.51z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M162.11 134.77c-0.78,3.26 -2,6.44 -3.68,9.45 -1.64,2.92 -3.68,5.65 -6.12,8.09 -2.44,2.44 -5.17,4.48 -8.09,6.11 -3,1.69 -6.19,2.92 -9.44,3.69l-1.48 -6.27c2.69,-0.64 5.32,-1.65 7.78,-3.03 2.37,-1.32 4.62,-3.01 6.67,-5.06 2.05,-2.05 3.74,-4.3 5.06,-6.66 1.38,-2.47 2.39,-5.1 3.03,-7.8l6.27 1.48z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M151.65 129.61c-0.36,2.76 -1.17,5.46 -2.43,7.98 -1.22,2.46 -2.84,4.75 -4.86,6.78 -2.02,2.02 -4.32,3.64 -6.78,4.86 -2.53,1.25 -5.23,2.06 -7.98,2.43l-0.83 -6.37c2.05,-0.27 4.06,-0.88 5.97,-1.82 1.81,-0.89 3.53,-2.11 5.06,-3.65 1.54,-1.54 2.76,-3.25 3.65,-5.06 0.94,-1.9 1.55,-3.92 1.82,-5.97l6.37 0.83z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M136.42 115.98c2.82,2.82 4.23,6.53 4.23,10.22 0,3.7 -1.41,7.4 -4.23,10.22 -2.82,2.82 -6.53,4.23 -10.22,4.23 -3.7,0 -7.4,-1.41 -10.22,-4.23l4.56 -4.56c1.56,1.57 3.61,2.35 5.66,2.35 2.05,0 4.1,-0.78 5.66,-2.34 1.57,-1.57 2.35,-3.62 2.35,-5.66 0,-2.05 -0.78,-4.1 -2.34,-5.66l4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M231.72 231.72c-13.78,13.79 -31.86,20.68 -49.93,20.68 -18.07,0 -36.14,-6.89 -49.93,-20.68 -1.48,-1.48 -2.94,-3.09 -4.38,-4.82 -1.38,-1.66 -2.69,-3.4 -3.93,-5.19l5.29 -3.63c1.09,1.59 2.28,3.17 3.57,4.71 1.18,1.42 2.52,2.88 4,4.37 12.53,12.53 28.95,18.79 45.37,18.79 16.42,0 32.84,-6.27 45.37,-18.79l4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M223.78 223.78c-11.59,11.59 -26.79,17.39 -41.99,17.39 -15.19,0 -30.4,-5.8 -41.99,-17.39 -2.02,-2.04 -3.89,-4.2 -5.58,-6.46 -1.73,-2.31 -3.26,-4.71 -4.6,-7.17l5.64 -3.07c1.2,2.21 2.57,4.35 4.1,6.39 1.49,1.99 3.15,3.92 4.99,5.75 10.35,10.34 23.9,15.5 37.44,15.5 13.55,0 27.09,-5.17 37.43,-15.5l4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M215.84 215.84c-9.4,9.4 -21.72,14.1 -34.05,14.1 -12.32,0 -24.64,-4.7 -34.05,-14.1 -3.13,-3.13 -5.76,-6.63 -7.88,-10.38 -2.18,-3.85 -3.78,-7.92 -4.81,-12.08l6.25 -1.54c0.9,3.64 2.28,7.16 4.15,10.47 1.8,3.18 4.08,6.2 6.85,8.96 8.14,8.14 18.82,12.21 29.49,12.21 10.67,0 21.34,-4.07 29.49,-12.21l4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M207.89 207.9c-7.21,7.21 -16.66,10.81 -26.1,10.81 -9.45,0 -18.9,-3.6 -26.11,-10.81 -2.44,-2.44 -4.48,-5.16 -6.1,-8.05 -1.66,-2.96 -2.89,-6.13 -3.67,-9.41l6.25 -1.48c0.64,2.65 1.65,5.26 3.04,7.74 1.33,2.37 3.01,4.61 5.04,6.64 5.95,5.95 13.75,8.93 21.55,8.93 7.8,0 15.6,-2.98 21.54,-8.93l4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M199.95 199.95c-5.01,5.01 -11.59,7.52 -18.16,7.52 -6.56,0 -13.13,-2.51 -18.15,-7.52 -2.03,-2.01 -3.65,-4.3 -4.86,-6.75 -1.25,-2.52 -2.06,-5.21 -2.43,-7.94l6.37 -0.86c0.28,2.05 0.89,4.06 1.83,5.95 0.89,1.8 2.11,3.51 3.64,5.04 3.75,3.76 8.68,5.63 13.6,5.63 4.92,0 9.85,-1.88 13.6,-5.63l4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M192 192.02c-2.82,2.82 -6.52,4.23 -10.21,4.23 -3.69,0 -7.39,-1.41 -10.21,-4.23 -2.84,-2.82 -4.25,-6.52 -4.25,-10.22 0,-3.7 1.41,-7.4 4.23,-10.22l4.56 4.56c-1.57,1.56 -2.35,3.61 -2.35,5.66 0,2.05 0.78,4.1 2.35,5.66 1.55,1.57 3.61,2.35 5.66,2.35 2.06,0 4.11,-0.78 5.68,-2.35l4.53 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M221.71 123.55c1.74,1.19 3.47,2.51 5.19,3.94 1.73,1.44 3.34,2.9 4.82,4.38 13.79,13.79 20.68,31.86 20.68,49.93 0,18.07 -6.9,36.14 -20.68,49.93l-4.56 -4.56c12.53,-12.53 18.79,-28.95 18.79,-45.37 0,-16.42 -6.27,-32.84 -18.79,-45.37 -1.48,-1.48 -2.94,-2.82 -4.37,-4.01 -1.49,-1.24 -3.06,-2.43 -4.71,-3.56l3.63 -5.31z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M210.15 129.62c2.46,1.34 4.86,2.87 7.16,4.6 2.3,1.72 4.46,3.58 6.46,5.58 11.59,11.59 17.39,26.79 17.39,41.99 0,15.19 -5.8,30.4 -17.39,41.99l-4.56 -4.56c10.34,-10.34 15.5,-23.88 15.5,-37.43 0,-13.55 -5.17,-27.1 -15.5,-37.43 -1.87,-1.87 -3.79,-3.54 -5.75,-5.01 -2.04,-1.53 -4.18,-2.89 -6.39,-4.09l3.07 -5.64z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M193.27 135.04c4.19,1.03 8.28,2.63 12.14,4.81 3.75,2.1 7.26,4.74 10.42,7.9 9.4,9.4 14.1,21.72 14.1,34.05 0,12.32 -4.7,24.64 -14.1,34.05l-4.56 -4.56c8.14,-8.14 12.21,-18.82 12.21,-29.49 0,-10.67 -4.07,-21.35 -12.21,-29.49 -2.75,-2.76 -5.79,-5.05 -9.01,-6.86 -3.32,-1.89 -6.87,-3.28 -10.51,-4.16l1.51 -6.25z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M190.36 145.88c3.24,0.77 6.42,2 9.44,3.68 2.92,1.62 5.64,3.67 8.1,6.12 7.21,7.21 10.81,16.66 10.81,26.11 0,9.45 -3.6,18.9 -10.81,26.1l-4.56 -4.56c5.95,-5.95 8.93,-13.75 8.93,-21.54 0,-7.8 -2.98,-15.6 -8.93,-21.55 -2.04,-2.04 -4.29,-3.73 -6.67,-5.06 -2.45,-1.38 -5.08,-2.39 -7.78,-3.03l1.48 -6.27z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M185.2 156.35c2.75,0.37 5.46,1.18 7.98,2.43 2.46,1.22 4.75,2.84 6.77,4.86 5.01,5.03 7.52,11.6 7.52,18.16 0,6.57 -2.51,13.15 -7.52,18.16l-4.56 -4.56c3.76,-3.76 5.63,-8.68 5.63,-13.6 0,-4.93 -1.88,-9.86 -5.62,-13.6 -1.55,-1.54 -3.26,-2.75 -5.07,-3.65 -1.9,-0.94 -3.92,-1.55 -5.96,-1.82l0.83 -6.37z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M171.57 171.57c2.82,-2.82 6.52,-4.23 10.22,-4.23 3.7,0 7.4,1.41 10.22,4.23 2.82,2.82 4.23,6.52 4.23,10.22 0,3.7 -1.41,7.4 -4.23,10.22l-4.56 -4.56c1.56,-1.56 2.35,-3.61 2.35,-5.66 0,-2.05 -0.78,-4.1 -2.35,-5.66 -1.56,-1.57 -3.61,-2.35 -5.66,-2.35 -2.05,0 -4.1,0.78 -5.66,2.35l-4.56 -4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M30.69 128.85c-1.8,-1.24 -3.53,-2.55 -5.19,-3.93 -1.73,-1.44 -3.34,-2.9 -4.82,-4.38 -13.79,-13.79 -20.68,-31.86 -20.68,-49.93 0,-18.07 6.89,-36.14 20.68,-49.93l4.56 4.56c-12.53,12.53 -18.79,28.95 -18.79,45.37 0,16.42 6.27,32.84 18.79,45.37 1.48,1.48 2.94,2.82 4.37,4 1.55,1.29 3.12,2.48 4.71,3.57l-3.63 5.29z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M42.25 122.78c-2.46,-1.34 -4.86,-2.88 -7.17,-4.6 -2.26,-1.69 -4.42,-3.55 -6.45,-5.59 -11.6,-11.58 -17.4,-26.79 -17.4,-41.98 0,-15.2 5.8,-30.4 17.39,-41.99l4.56 4.56c-10.34,10.34 -15.5,23.88 -15.5,37.43 0,13.55 5.17,27.1 15.5,37.43 1.83,1.85 3.76,3.51 5.75,5 2.04,1.53 4.18,2.89 6.39,4.1l-3.07 5.64z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M59.02 117.34c-4.16,-1.03 -8.23,-2.63 -12.08,-4.81 -3.74,-2.12 -7.24,-4.75 -10.38,-7.88 -9.4,-9.4 -14.1,-21.73 -14.1,-34.05 0,-12.32 4.7,-24.65 14.1,-34.05l4.56 4.56c-8.14,8.14 -12.21,18.81 -12.21,29.49 0,10.67 4.07,21.34 12.21,29.49 2.77,2.77 5.79,5.05 8.96,6.85 3.31,1.87 6.83,3.25 10.47,4.15l-1.54 6.25z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M61.97 106.49c-3.27,-0.78 -6.45,-2.01 -9.41,-3.67 -2.89,-1.62 -5.61,-3.66 -8.05,-6.1 -7.21,-7.21 -10.81,-16.66 -10.81,-26.11 0,-9.45 3.6,-18.9 10.81,-26.1l4.56 4.56c-5.95,5.95 -8.93,13.75 -8.93,21.54 0,7.8 2.98,15.6 8.93,21.55 2.03,2.03 4.27,3.71 6.64,5.04 2.48,1.39 5.09,2.41 7.74,3.04l-1.48 6.25z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M67.14 96.05c-2.74,-0.37 -5.43,-1.18 -7.94,-2.43 -2.45,-1.21 -4.74,-2.83 -6.75,-4.84 -5.01,-5.03 -7.52,-11.6 -7.52,-18.16 0,-6.57 2.51,-13.15 7.52,-18.16l4.56 4.56c-3.76,3.75 -5.63,8.68 -5.63,13.6 0,4.93 1.88,9.86 5.63,13.61 1.54,1.53 3.24,2.74 5.04,3.63 1.89,0.94 3.91,1.55 5.95,1.83l-0.86 6.37z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M80.83 80.83c-2.82,2.82 -6.52,4.23 -10.22,4.23 -3.7,0 -7.4,-1.41 -10.22,-4.23 -2.82,-2.84 -4.23,-6.53 -4.23,-10.22 0,-3.69 1.41,-7.39 4.23,-10.21l4.56 4.53c-1.56,1.57 -2.35,3.62 -2.35,5.68 0,2.05 0.78,4.11 2.34,5.67 1.57,1.56 3.62,2.34 5.67,2.34 2.05,0 4.1,-0.78 5.66,-2.35l4.56 4.56z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M123.54 34.32c-1.13,-1.65 -2.32,-3.22 -3.56,-4.71 -1.19,-1.42 -2.52,-2.88 -4.01,-4.37 -12.53,-12.53 -28.95,-18.79 -45.37,-18.79 -16.42,0 -32.84,6.27 -45.37,18.79l-4.56 -4.56c13.78,-13.79 31.86,-20.68 49.93,-20.68 18.07,0 36.14,6.9 49.93,20.68 1.48,1.48 2.94,3.09 4.38,4.82 1.43,1.72 2.74,3.45 3.94,5.19l-5.31 3.63z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M117.13 45.32c-1.2,-2.21 -2.57,-4.35 -4.09,-6.39 -1.47,-1.96 -3.14,-3.88 -5.01,-5.75 -10.33,-10.34 -23.88,-15.5 -37.43,-15.5 -13.55,0 -27.09,5.17 -37.43,15.5l-4.56 -4.56c11.59,-11.59 26.79,-17.39 41.99,-17.39 15.2,0 30.4,5.8 41.99,17.39 2,2 3.86,4.16 5.58,6.46 1.73,2.3 3.26,4.7 4.6,7.16l-5.64 3.07z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M111.11 60.64c-0.89,-3.64 -2.27,-7.18 -4.15,-10.51 -1.82,-3.22 -4.11,-6.25 -6.87,-9.01 -8.14,-8.14 -18.81,-12.21 -29.49,-12.21 -10.67,0 -21.34,4.07 -29.49,12.21l-4.56 -4.56c9.4,-9.4 21.73,-14.1 34.05,-14.1 12.32,0 24.65,4.7 34.05,14.1 3.16,3.17 5.8,6.68 7.91,10.42 2.17,3.86 3.77,7.95 4.8,12.14l-6.25 1.51z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M100.25 63.52c-0.64,-2.71 -1.65,-5.34 -3.02,-7.79 -1.34,-2.38 -3.03,-4.63 -5.07,-6.67 -5.95,-5.95 -13.75,-8.93 -21.55,-8.93 -7.8,0 -15.59,2.98 -21.54,8.93l-4.56 -4.56c7.21,-7.21 16.66,-10.81 26.1,-10.81 9.45,0 18.9,3.6 26.11,10.81 2.45,2.45 4.5,5.18 6.12,8.08 1.68,3.02 2.92,6.2 3.68,9.45l-6.27 1.48z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M89.68 68.03c-0.27,-2.04 -0.88,-4.06 -1.82,-5.96 -0.9,-1.81 -2.11,-3.53 -3.65,-5.06 -3.74,-3.76 -8.67,-5.63 -13.6,-5.63 -4.92,0 -9.85,1.88 -13.6,5.63l-4.56 -4.56c5.01,-5.02 11.59,-7.52 18.16,-7.52 6.56,0 13.13,2.51 18.15,7.53 2.03,2.01 3.65,4.31 4.87,6.77 1.25,2.52 2.06,5.23 2.43,7.98l-6.37 0.83z"
      ></motion.path>
      <motion.path
        variants={pathVariants}
        initial="hidden"
        animate="visible"
        d="M76.27 76.27c1.57,-1.56 2.35,-3.61 2.35,-5.66 0,-2.05 -0.78,-4.1 -2.35,-5.66 -1.56,-1.56 -3.61,-2.35 -5.66,-2.35 -2.05,0 -4.1,0.78 -5.66,2.35l-4.56 -4.56c2.82,-2.82 6.52,-4.23 10.22,-4.23 3.7,0 7.4,1.41 10.22,4.23 2.82,2.82 4.23,6.52 4.23,10.22 0,3.7 -1.41,7.4 -4.23,10.22l-4.56 -4.56z"
      ></motion.path>
    </motion.svg>
  ),
});

export default IconPattern;
